<template>
  <el-dialog title="Bestellung versenden" :visible="show" @close="close" width="70%">
    <div class="row">
      <div class="col-sm-12">
        <form @submit.prevent="submit">
          <fg-input label="E-Mail Adresse Empfänger" type="text" v-model="email"
            :error="valErrors['email'] ? valErrors['email'][0] : null" />
          <fg-input label="E-Mail Betreff" type="text" v-model="emailSubject"
            :error="valErrors['email_subject'] ? valErrors['email_subject'][0] : null" />
          <div class="form-group has-label">
            <label>Email Text</label>

            <Editor  v-model="emailText" api-key="75rbn6zzzmflhpysdjlnasy2oma7dk2f0cxs85ary6ma5ga4" :init="editorConfig" />
          </div>
          <div class="d-flex justify-content-between">
            <button type="submit" class="btn btn-fill btn-primary" :disabled="!canSubmit">
              Versenden
            </button>
            <a :href="`${api}/orders/${order.id}/send?email_text=${encodeURIComponent(emailText)}`" target="_blank"
              class="btn btn-fill btn-warning">
              Vorschau
            </a>
            <button class="btn btn-fill btn-default" @click.prevent="close">
              Abbrechen
            </button>
          </div>
        </form>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { Dialog } from 'element-ui'
import api from 'src/api'
import Editor from '@tinymce/tinymce-vue'

export default {
  props: ['show', 'contactPeople', 'order'],
  components: { [Dialog.name]: Dialog, Editor },
  data() {
    return {
      api,
      contactPerson: null,
      email: this.order.email,
      emailText: this.order.email_text,
      emailSubject: this.order.email_subject,
      valErrors: [],
      editorConfig: {
        height: 300,
        apiKey: 'e9hzyqvby9nbkc6mpwc66s78s7n6i2as0880cpz6lgysn2td',
        plugins: 'lists link image table code help wordcount',
      },

    }
  },
  computed: {
    canSubmit() {
      return true
    }
  },
  methods: {
    submit() {
      this.$http.post(`/orders/${this.order.id}/send`, {
        email: this.email,
        email_text: this.emailText,
        email_subject: this.emailSubject
      }).then(({ data }) => {
        this.$emit('orderSent', data)
        this.$notify({
          message: 'Bestellung erfolgreich versendet.',
          type: 'success'
        })
      }).catch(({ response }) => { this.valErrors = response.data.errors })
    },
    close() {
      this.$emit('close')
    },
  }
}
</script>

<style></style>
